module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_8011.fa9bd092.png";